export const FEATURE_FLAGS = {
  SEARCH_CTA_TEXT: 'feature_search_cta_text',
} as const

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS]
